import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";

/**
 * LeftRail Postfach badge = the number of your tickets with UNSEEN updates,
 * driven by the same notification read-state as the per-card dots and the bell.
 * (Was a separate localStorage "last visited" timestamp model that disagreed
 * with the cards — opening a ticket from the board cleared the dot but not the
 * badge.) Opening a ticket marks its notifications read (useMarkRowSeen), which
 * decrements this too.
 */
export function useUnreadSubmissionsCount(): number {
  const submissions = useQuery({
    queryKey: queryKeys.mySubmissions,
    queryFn: () => api.listMySubmissions(),
  });

  return useMemo(
    () => (submissions.data ?? []).filter((s) => s.unread_notification_count > 0).length,
    [submissions.data],
  );
}
